export default "__VITE_ASSET__DajKOln9__"